import { OT_UPDATED_EVENT_NAME } from './constants';
import { isGroupConsentGiven } from './helpers';

export default function onceCookiesGroupConsentGiven(group, callback) {
  // OneTrust is not present - just do what you wanted
  if (!window.OneTrust) {
    callback();
    return;
  }

  // Consent already given
  if (isGroupConsentGiven(group)) {
    callback();
    return;
  }

  // Listen to consent changed event, once consent is given - do callback and remove listener
  const eventListener = () => {
    if (isGroupConsentGiven(group)) {
      callback();
      document.removeEventListener(OT_UPDATED_EVENT_NAME, eventListener);
    }
  };

  document.addEventListener(OT_UPDATED_EVENT_NAME, eventListener);
}
